import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getManagersStats, clearManagersStats } from 'actions/superuser';
import { HorizontalBar } from 'react-chartjs-2';
import PropTypes from 'prop-types';
import 'chartjs-plugin-colorschemes';

import './StatsAcc.css';
import { transformStats } from 'utils/stat_utils';
import { DateTimePicker } from 'elements';

function mapState(state) {
  return {
    ...state.superuser
  };
}

function mapDispatch(dispatch, props) {
  return {
    clearManagersStats() {
      return clearManagersStats(dispatch);
    },
    getManagersStats(data) {
      return getManagersStats(dispatch, data, props.pt);
    }
  };
}

export const chartPageType = {
  messagesTime: 'messagesTime',
  conversions: 'conversions'
};

class StatsAcc extends Component {

  state = {
    dateStart: null,
    dateEnd: null
  };

  static propTypes = {
    pt: PropTypes.string,
    managersStats: PropTypes.object,
    clearManagersStats: PropTypes.func,
    getManagersStats: PropTypes.func
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.pt !== nextProps.pt) {
      this.props.clearManagersStats();
      this.setState({ dateStart: null, dateEnd: null });
    }
  }

  componentWillUnmount() {
    this.props.clearManagersStats();
  }

  handleDateRangeChange(dateStart, dateEnd) {
    this.setState({ dateEnd, dateStart });
    this.handleStatChange(dateStart, dateEnd);
  }

  handleStatChange(dateStart, dateEnd) {
    if (dateStart && dateEnd) {
      const data = {
        dateEnd: dateEnd.format(),
        dateStart: dateStart.format('YYYY-MM-DD HH:mm:ss')
      };
      this.props.getManagersStats(data);
    }
  }

  get selectDateRange() {
    const { dateStart, dateEnd } = this.state;
    return <DateTimePicker
      value={ [dateStart, dateEnd] }
      exportData={ (a, b) => this.handleDateRangeChange(a, b) }
    />;
  }

  get chartHeight() {
    return 600;
  }

  get pageTitle() {
    switch (this.props.pt) {
      case chartPageType.conversions:
        return 'Conversion stats';
      case chartPageType.messagesTime:
      default:
        return 'Managers comparison';
    }
  }

  get charts() {
    const { managersStats, pt } = this.props;

    const transformedStats = transformStats(managersStats);
    const rawEnvs = Object.keys(managersStats);
    const envs = rawEnvs.sort();

    const managerUUIDs = Object.keys(transformedStats);
    const labels = [...envs, 'All Products'];

    const freeMessagesData = {
      datasets: managerUUIDs.map(i => ({
        data: transformedStats[i].nFreeAnswers,
        label: transformedStats[i].username
      })),
      labels
    };

    const paidMessagesData = {
      datasets: managerUUIDs.map(i => ({
        data: transformedStats[i].nPaidAnswers,
        label: transformedStats[i].username
      })),
      labels
    };

    const messageData = {
      datasets: managerUUIDs.map(i => ({
        data: transformedStats[i].nPaidAnswers.map((v, k) => v + transformedStats[i].nFreeAnswers[k]),
        label: transformedStats[i].username
      })),
      labels
    };

    const timeMessagesData = {
      datasets: managerUUIDs.map(i => ({
        data: transformedStats[i].nTime,
        label: transformedStats[i].username
      })),
      labels
    };

    const firstMessageRepliesData = {
      datasets: managerUUIDs.map(i => ({
        data: transformedStats[i].nFirstMessageReplies,
        label: transformedStats[i].username
      })),
      labels
    };

    const conversionsData = {
      datasets: managerUUIDs.map(i => ({
        data: transformedStats[i].nConversions,
        label: transformedStats[i].username
      })),
      labels
    };

    const conversionRateData = {
      datasets: managerUUIDs.map(i => ({
        data: transformedStats[i].nConversions.map((v, k) => 100 * v / transformedStats[i].nFirstMessageReplies[k] || 0),
        label: transformedStats[i].username
      })),
      labels
    };

    if (!envs.length) return [];
    switch (pt) { // page type
      case chartPageType.messagesTime:
        return [[freeMessagesData, 'Free & loyalty questions answers'],
          [paidMessagesData, 'Paid questions answers'],
          [messageData, 'All questions answers'],
          [timeMessagesData, 'Time spent (minutes)']];
      case chartPageType.conversions:
        return [[conversionsData, 'Conversions'],
          [firstMessageRepliesData, 'FREE questions answered'],
          [conversionRateData, 'Conversion rate (%)']];
    }
  }

  render() {
    const { dateStart, dateEnd } = this.state;

    return (
      <div className="stat-container">
        <div className="page-title">{ this.pageTitle }</div>
        { this.selectDateRange }
        { (dateStart && dateEnd) &&
        <div className="env-stats">
          <div>
            from: { dateStart.format('YYYY/MM/DD HH:mm:ss') }
          </div>
          <div>
            to: { dateEnd.format('YYYY/MM/DD HH:mm:ss') }
          </div>
        </div>
        }
        { this.charts
          .map((v, i) => (
            <div key={ i }>
              <HorizontalBar
                data={ v[0] }
                height={ this.chartHeight }
                options={ {
                  maintainAspectRatio: false,
                  plugins: {
                    colorschemes: {
                      scheme: 'tableau.Classic20'
                    }
                  },
                  legend: {
                    display: true,
                    position: 'left',
                    align: 'start'
                  },
                  title: {
                    display: true,
                    text: v[1]
                  },
                  scales: {
                    xAxes: [{
                      ticks: {
                        beginAtZero: true
                      }
                    }]
                  }
                } }
              />
            </div>))
        }
      </div>
    );
  }
}

export default withRouter(connect(mapState, mapDispatch)(StatsAcc));



// WEBPACK FOOTER //
// ./src/pages/stats_acc/StatsAcc.jsx